import { useSelector } from 'react-redux';
import { FEATURE_KEYS } from '@medflex/utils/subscriptionEnums';
import { NAME } from '../store/models/subscription';

const useFeatures = (keys = []) => {
  const unknownFeatures = keys.filter(
    key => !Object.values(FEATURE_KEYS).some(featureKey => featureKey === key),
  );
  if (unknownFeatures.length > 0)
    throw new Error(`useFeatures(): Unknown features passed (${unknownFeatures.join(',')})`);

  const { features } = useSelector(state => state[NAME]);

  return features
    ? keys.map(key => ({
        key,
        ...features[key],
      }))
    : [];
};

export default useFeatures;
